"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreateButton = CreateButton;
exports.LabelField = LabelField;
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _formik = require("formik");

var _reactI18next = require("react-i18next");

var _trim = _interopRequireDefault(require("lodash/trim"));

var _noop = _interopRequireDefault(require("lodash/noop"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Search = _interopRequireDefault(require("@material-ui/icons/Search"));

var _Checkbox = _interopRequireDefault(require("../Checkbox"));

var _Tooltip = _interopRequireDefault(require("../Tooltip"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _default = function _default(_ref) {
  var labels = _ref.labels,
      renderField = _ref.renderField,
      renderButton = _ref.renderButton,
      validate = _ref.validate;
  var labelNames = labels.map(function (item) {
    return item.name.toLowerCase();
  }).filter(Boolean);
  return /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
    enableReinitialize: true,
    validate: validate,
    initialValues: {
      labels: labels,
      name: ''
    },
    render: function render(formikProps) {
      var values = formikProps.values;
      var filteredLabels = values.labels.filter(function (item) {
        return item.name.toString().toLowerCase().includes((0, _trim["default"])(values.name).toLowerCase());
      }).map(function (item) {
        return item.id;
      });
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex items-center mx-6 my-2 border-b text-gray-light"
      }, /*#__PURE__*/_react["default"].createElement(_Search["default"], {
        fontSize: "small"
      }), /*#__PURE__*/_react["default"].createElement(_formik.Field, {
        autoFocus: true,
        name: "name",
        autoComplete: "off",
        className: "flex-1 w-full mx-2 bg-transparent",
        placeholder: "Label as..."
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "overflow-y-scroll",
        style: {
          maxHeight: 210
        }
      }, values.labels.map(function (each, index) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: each.id,
          className: (0, _classnames["default"])({
            hidden: !filteredLabels.includes(each.id)
          })
        }, renderField({
          label: each,
          index: index,
          formikProps: formikProps
        }));
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "px-6"
      }, !labelNames.includes(formikProps.values.name) && formikProps.values.name && /*#__PURE__*/_react["default"].createElement("div", {
        className: "py-2"
      }, renderButton({
        name: values.name,
        formikProps: formikProps
      }))));
    }
  });
};

exports["default"] = _default;

function CreateButton(_ref2) {
  var name = _ref2.name,
      onClick = _ref2.onClick;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react["default"].createElement("button", {
    className: "w-full px-4 py-1 text-left truncate shadow rounded hover:bg-secondary dark:bg-secondary dark:hover:bg-app",
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-semibold text-gray-light"
  }, t('settings.label.selector.create')), /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-bold truncate text-primary"
  }, name));
}

function LabelField(_ref3) {
  var multi = _ref3.multi,
      index = _ref3.index,
      onClick = _ref3.onClick;
  var fieldName = "labels.".concat(index);
  return multi ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "pl-4 pr-6 hover:bg-secondary"
  }, /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: fieldName,
    render: function render(_ref4) {
      var field = _ref4.field,
          form = _ref4.form;
      return /*#__PURE__*/_react["default"].createElement("label", {
        className: "block truncate cursor-pointer select-none"
      }, multi && /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
        size: "small",
        iconSize: "small",
        checked: field.value.checked,
        onChange: function onChange(value) {
          form.setFieldValue("".concat(field.name, ".checked"), value);
          onClick(_objectSpread(_objectSpread({}, field.value), {}, {
            checked: value
          }));
        }
      }), /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
        title: field.value.name
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: (0, _classnames["default"])('font-light', {
          'px-4 py-2': !multi
        }),
        onClick: multi ? _noop["default"] : function () {
          return onClick(field.value);
        }
      }, field.value.name)));
    }
  })) : /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: fieldName,
    render: function render(_ref5) {
      var field = _ref5.field,
          form = _ref5.form;
      return /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
        title: field.value.name
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "font-light truncate px-6 py-2 hover:bg-secondary cursor-pointer",
        onClick: multi ? _noop["default"] : function () {
          return onClick(field.value);
        }
      }, field.value.name));
    }
  });
}
//# sourceMappingURL=LabelSelector.js.map